import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components'
//import layout from '../../layout.json'


class DisplayLayout extends Component {
    render() {
        //    const StyledWrapper = styled.div`${Layout.css}`
        const { active, layouts } = this.props;

        return active ? <>
            {
                layouts.map((item, index) => {
                    const StyledWrapper = styled.div`${item.css}min-width:100px;`
                    return active == item.id && <StyledWrapper>
                        {
                            item.zones.map((zItem, zIndex) => <div id={zItem.id} className="zone"></div>)
                        }
                    </StyledWrapper>

                })
            }
        </> : <>
                {
                    layouts.map((item, index) => {
                        const StyledWrapper = styled.div`${item.css}`
                        return <StyledWrapper>
                            {
                                item.zones.map((zItem, zIndex) => <div id={zItem.id} className="zone"></div>)
                            }
                        </StyledWrapper>

                    })
                }
            </>
    }
}

const mapStateToProps = state => {
    return {
        layouts: state.layout.layouts
    }
}
export default connect(mapStateToProps)(DisplayLayout);